import request from "../utils/http";

/**
 * 包含列表字段、详情、处理等字段信息
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export  function getViewConfig(data) {
  return  request({
    url:'/view/getViewConfig',
    method:'post',
    data:data
  });
}

export  function getNavLink(data) {
  return  request({
      url:'/system/getNavLink',
      method:'post',
      data: data
    }
  )
}
